import { render } from "./activity-compose.vue?vue&type=template&id=3aa0383b"
import script from "./activity-compose.vue?vue&type=script&lang=js"
export * from "./activity-compose.vue?vue&type=script&lang=js"

import "./activity-compose.vue?vue&type=style&index=0&id=3aa0383b&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__